import React from 'react';
import { TruncatedCell } from '@/components/table';
import { formatJobItemError } from '@/utils/jobItemErrors';

type Props = {
  value?: string | null;
  maxWidth?: number | string;
  copyable?: boolean;
};

/** Operational error text with secret redaction (not full masking). */
export default function OperationalErrorCell({ value, maxWidth, copyable = false }: Props) {
  if (!value?.trim()) {
    return <span className="muted">—</span>;
  }
  const display = formatJobItemError(value);
  return (
    <TruncatedCell value={display} title={display} maxWidth={maxWidth} copyable={copyable} />
  );
}
